import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import RewardConvert from './RewardConvert';
import CurrentPromo from '../account/CurrentPromo';
import useAxios
 from '../../axios/useAxios';
import GiftCardSlider from './GiftCardSlider';
import GiftCardDetailSlider from '../../components/slider/GiftCardDetailSlider';
import cadeaubackground from '../../styles/img/background/cadeau-background.svg';
import BackButton from '../../components/button/BackButton';
import PikkoPointContainer from '../../components/pikko-box/PikkoPointContainer';
import { ACCOUNT } from '../../constants/routes';
import { useNavigate } from 'react-router';
import { formatFidelityPoints } from '../../utils/StringUtils';
import { notifySuccess, notifyConfirmation } from '../../utils/Notify';
import { purchasePromo } from '../../actions/userActions';
import { getPromo } from '../../actions/cartActions';
import { CART } from '../../constants/routes';
import { useDispatch } from 'react-redux';
import { PROMO } from '../../constants/routes';
import ConversionTile from '../promo/ConversionTile';
import couponRemise from '../../styles/img/coupon-remise.png';
import PikkoPointLayout from '../../components/pikko-box/PikkoPointLayout';

const RewardScreen = () => {
  const user = useSelector((state) => state.user);
  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const [selectedPromoLoading, setSelectedPromoLoading] = useState(undefined);
  const [promoToPurchase, setPromoToPurchase] = useState([]);
  const [giftCards, setGiftCards] = useState([]);
  const [selectedGiftCard, setSelectedGiftCard] = useState(undefined);
  const [showGiftCards, setShowGiftCards] = useState(false);
  const [isGiftCardLoading, setIsGiftCardLoading] = useState(false);
  
  useEffect(() => {
    setIsGiftCardLoading(true);
    axiosInstance
      .get('/promos/giftCards')
      .then((response) => setGiftCards(response.data))
      .finally(() => setIsGiftCardLoading(false));
  }, []);

  const closeGiftCardDetailSlider = () => {
    setSelectedGiftCard(undefined);
  };

  const closeGiftCardSlider = () => {
    setShowGiftCards(false);
  };

  useEffect(() => {
    axiosInstance
      .get('/promos/purchase')
      .then((response) => setPromoToPurchase(response.data))
      .catch((error) => console.error({ error }));
  }, []);

  const isPromoDisabled = (promoItem) => {
    return (
      user.fidelity < promoItem.cost ||
      (selectedPromoLoading !== undefined &&
        selectedPromoLoading !== promoItem._id)
    );
  };

  const callBackRedirect = (promoItem) => {
    notifySuccess(
      'Promotion appliquée',
      `Ta promotion de ${promoItem.price}€ vient d'être appliquée à ton panier.`,
      "J'ai compris",
    );
    if (cartItems.itemsPrice > 0) {
      navigate(CART);
      notifySuccess('Bravo', 'Ton achat a été validé !', 'Super');
    }
  };

  const handlePurchasePromo = (promoItem, autoActivation) => {
    axiosInstance
      .get(`/user/${user._id}/promotion/${promoItem._id}`)
      .then((response) => {
        dispatch(purchasePromo(response.data));
        if (autoActivation) {
          // Dans ce cas, on active automatiquement le coupon et on renvoie vers la page de promo
          dispatch(
            getPromo(cartItems, axiosInstance, promoItem, () =>
              callBackRedirect(promoItem),
            ),
          );
        } else {
          if (cartItems.itemsPrice > 0) {
            navigate(PROMO);
          }
          notifySuccess('Bravo', 'Ton achat a été validé !', 'Super');
        }
      })
      .catch((error) => console.log({ error }))
      .finally(() => setSelectedPromoLoading(undefined));
  };

  const onPromoClick = (promoItem) => {
    if (cartItems.itemsPrice - promoItem.price < 1) {
      notifyConfirmation(
        'Attention',
        `Si tu convertis tes points, tu ne pourras pas profiter de cette promotion sur ton panier. Le montant total ne doit pas être inférieur à 1€.`,
        'Oui',
        'Non',
        () => handlePurchasePromo(promoItem),
        'warning',
      );
    } else {
      notifyConfirmation(
        'Convertis tes points',
        `Es-tu sûr de vouloir convertir tes ${formatFidelityPoints(promoItem.cost)} Pikkos points ?`,
        'Oui',
        'Non',
        () => handlePurchasePromo(promoItem, true),
      );
    }
  };

  if (!user._id) {
    return <></>;
  }
  return (
    <>
      <PikkoPointLayout onBack={() => navigate(ACCOUNT)}>
        <div className="conversion-tile-container">
          {promoToPurchase.map((promoItem) => (
            <ConversionTile
              key={promoItem._id}
              name={promoItem.description}
              cost={formatFidelityPoints(promoItem.cost)}
              icon={couponRemise}
              disabled={isPromoDisabled(promoItem)}
              onValidate={() => onPromoClick(promoItem)}
              isLoading={promoItem._id === selectedPromoLoading}
            />
          ))}
          <RewardConvert showGiftCards={() => setShowGiftCards(true)} />
          <CurrentPromo user={user} />
          {/*{showGiftCards && (*/}
          {/*<> <GiftCardSlider*/}
          {/*    giftCards={giftCards}*/}
          {/*    isOpen={showGiftCards}*/}
          {/*    onCompleteClose={closeGiftCardDetailSlider}*/}
          {/*    onClose={closeGiftCardSlider}*/}
          {/*    onSelectItem={setSelectedGiftCard}*/}
          {/*    isLoading={isGiftCardLoading}*/}
          {/*    />*/}
          {/*    <GiftCardDetailSlider*/}
          {/*    isOpen={!!selectedGiftCard}*/}
          {/*    onClose={closeGiftCardDetailSlider}*/}
          {/*    onCompleteClose={closeGiftCardSlider}*/}
          {/*    onSuccess={closeGiftCardSlider}*/}
          {/*    giftCard={selectedGiftCard}*/}
          {/*    user={user}*/}
          {/*/></>*/}
          {/*)}*/}
        </div>
        {/* <GiftSurprise user={user} giflocation={'back-button'} /> */}
      </PikkoPointLayout>
    </>
  );
};

export default RewardScreen;
